import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text } from "@mantine/core";
import { DEFAULT_THEME } from "../../shared/util/consts";
import { useAuth } from "../../shared/contexts/AuthContext";

import "./Login.css"; // Import your CSS file for styles
import LoadingSpinner from "../../shared/components/LoadingSpinner";

const Login: React.FC = () => {
  // Use the AuthContext to manage authentication state
  const { login, signUp } = useAuth(); // Assuming you have a login function in your AuthContext
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [issue, setIssue] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setIssue("");
      if (!email || !password) {
        setIssue("Please provide both email and password.");
        return;
      }
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        setIssue("Please provide a valid email address.");
        return;
      }
      setIsLoading(true);
      await login(email, password);
      navigate("/");
    } catch (error) {
      setIssue(
        (error as { message?: string })?.message ??
          "An error occurred during login."
      );
    }
    setIsLoading(false);
  };
  const handleSignUp = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setIssue("");
      if (!email || !password) {
        setIssue("Please provide both email and password.");
        return;
      }
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        setIssue("Please provide a valid email address.");
        return;
      }
      if (password.length < 6) {
        setIssue("Password must be at least 6 characters long.");
        return;
      }
      setIsLoading(true);
      await signUp(email, password);
      navigate("/");
    } catch (error) {
      setIssue(
        (error as { message?: string })?.message ??
          "An error occurred during login."
      );
    }
    setIsLoading(false);
  };

  return (
    <Box
      className="login-container"
      style={{
        backgroundColor: DEFAULT_THEME.BackgroundColor,
        color: DEFAULT_THEME.TextColor,
        height: "calc(100dvh)",
      }}
    >
      <Box
        className="login-container-border"
        style={{
          border: "2px solid #fff",
          borderRadius: "10px",
          margin: "10px",
          justifyContent: "space-between",
        }}
      >
        <form onSubmit={handleLogin}>
          <Text style={{ fontSize: "30px" }}>Login/Sign up to Cast</Text>
          <div>
            <input
              className="login-field"
              placeholder="EMAIL"
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              className="login-field"
              placeholder="PASSWORD"
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <Box>
            <button
              type="submit"
              className="login-button"
              style={{
                backgroundColor: DEFAULT_THEME.BackgroundColor,
                color: DEFAULT_THEME.TextColor,
                border: "1px solid #fff",
                borderRadius: "5px",
              }}
            >
              Login
            </button>
            <button
              onClick={handleSignUp}
              className="login-button"
              style={{
                backgroundColor: DEFAULT_THEME.BackgroundColor,
                color: DEFAULT_THEME.TextColor,
                border: "1px solid #fff",
                borderRadius: "5px",
              }}
            >
              Sign Up
            </button>
            <Text style={{ fontSize: "20px" }}>{issue}</Text>
          </Box>
        </form>
        {isLoading && <LoadingSpinner asOverlay={false} />}
      </Box>
    </Box>
  );
};

export default Login;
